
<template>
  <!--工程账号-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="userId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :rowOptLen="4"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="true"
    >
    </x-tabula>
  </div>
</template>

<script>
export default {
  name: 'projectAccount',
  data () {
    return {
      searchList: [
        { props: ['userName'], placeholder: '账号名', inputType: 'input' },
        { props: ['mobile'], placeholder: '手机号', inputType: 'input' },
        { props: ['status'], placeholder: '选择状态', options: this.$store.state.statusList, inputType: 'select' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['community:project:add'] },
        { text: '删除', icon: 'close', disabled: true, permi: ['community:project:delete'] }
      ],
      rowOptList: [
        // { text: '重置密码', handle: row => this.resetPwd(row.encrypt_id), key: 'resetPwd' },
        { text: '修改', handle: row => this.$refs.table.toEdit(row), permi: ['community:project:add'] },
        { text: '删除', handle: row => this.$refs.table.showDeleteConfirm(row), permi: ['community:project:delete'] }
      ],
      columns: [
        { title: '账号名', dataIndex: 'userName', align: 'left', width: '' },
        { title: '手机', dataIndex: 'mobile', align: 'left', width: '' },
        { title: '真实姓名', dataIndex: 'trueName', align: 'left', width: '' },
        { title: '创建人', dataIndex: 'createBy', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '状态', dataIndex: 'statusDesc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        userName: undefined,
        mobile: undefined,
        status: undefined
      },
      listApi: {
        url: '/project/user/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addProjectAccount',
        addTitle: '新增工程账号',
        editTitle: '修改工程账号'
      },
      deleteParam: {
        url: '/project/user/',
        title: '工程账号',
        key: 'userName'
      }
    };
  },
  mounted () {
  },
  methods: {
    /* 重置密码 */
    resetPwd (id) {
      this.$post({
        url: '/projecter/reset_password',
        params: { user_id: id }
      }).then((res) => {
        this.$message.success('密码重置成功');
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
